import { render, staticRenderFns } from "./ButtonToggle.vue?vue&type=template&id=6a23dc12&scoped=true&"
import script from "./ButtonToggle.vue?vue&type=script&lang=ts&"
export * from "./ButtonToggle.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonToggle.vue?vue&type=style&index=0&id=6a23dc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23dc12",
  null
  
)

export default component.exports